// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getDatabase, ref, set, push, child, get } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB12bzeQFEK_SQY861rRZFKT0_9tqdhHgg",
  authDomain: "transdirectorytt.firebaseapp.com",
  projectId: "transdirectorytt",
  storageBucket: "transdirectorytt.firebasestorage.app",
  messagingSenderId: "869304508991",
  appId: "1:869304508991:web:f2411a08fb4dca11f40e8a",
  measurementId: "G-6KT0YYC57T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const dbRef = ref(getDatabase());
const database = getDatabase(app);

var count = 0;

get(child(dbRef, "service-providers")).then((snapshot) => {
  if (snapshot.exists()) {
    document.getElementById("loading-animation").style.display = "none";

    snapshot.forEach(element => {
        createServiceProviderElement(
          element.val().entityName, 
          element.val().category,
          element.val().address,
          element.val().affiliation,
          element.val().contactNumber,
          element.val().email,
          element.val().entityType,
          element.val().price,
          element.val().tags,
          element.val().website,
          element.key
        );
    });
  } 
  else {
    console.log("No data available");
  }
}).catch((error) => {
  console.error(error);
});

//Displaying the list of service providders in the website:
function createServiceProviderElement(name, category, address, affiliation, contactNumber, email, entityType, price, tags, website, providerID) {
  count++;
  var listItemHolder = document.getElementById("modal-content");
  var listItem = document.createElement("div");
  listItem.classList.add("service-provider-list-item");

  var header = document.createElement("div");
  header.classList.add("service-provider-list-item-header");
  listItem.appendChild(header);
  header.tabIndex = count;

  var collapseArrow = document.createElement("img");
  collapseArrow.setAttribute("src", "/arrow.e2318ae3.svg");
  header.appendChild(collapseArrow);

  var listItemTitleHolder = document.createElement("div");
  listItemTitleHolder.classList.add("list-content-title-container");
  header.appendChild(listItemTitleHolder);

  var nameElement = document.createElement("h4");
  nameElement.innerHTML = name;

  var categoryElement = document.createElement("p");
  categoryElement.innerHTML = category;

  var contentDiv = document.createElement("div");
  contentDiv.classList.add("service-provider-content");
  listItem.appendChild(contentDiv);

  var nameItem = document.createElement("div");
  var nameTitle = document.createElement("h5");
  var nameP = document.createElement("p");
  nameItem.classList.add("line-item");
  nameItem.appendChild(nameTitle);
  nameItem.appendChild(nameP);
  contentDiv.appendChild(nameItem);
  nameTitle.innerHTML = "Name: ";
  nameP.innerHTML = name;

  var locationItem = document.createElement("div");
  var locationTitle = document.createElement("h5");
  var locationP = document.createElement("p");
  locationItem.classList.add("line-item");
  locationItem.appendChild(locationTitle);
  locationItem.appendChild(locationP);
  contentDiv.appendChild(locationItem);
  locationTitle.innerHTML = "Location: ";
  locationP.innerHTML = address;
  
  var affiliationItem = document.createElement("div");
  var affiliationTitle = document.createElement("h5");
  var affiliationP = document.createElement("p");
  affiliationItem.classList.add("line-item");
  affiliationItem.appendChild(affiliationTitle);
  affiliationItem.appendChild(affiliationP);
  contentDiv.appendChild(affiliationItem);
  affiliationTitle.innerHTML = "Affiliation to Community: ";
  affiliationP.innerHTML = affiliation;

  var categoryItem = document.createElement("div");
  var categoryTitle = document.createElement("h5");
  var categoryP = document.createElement("p");
  categoryItem.classList.add("line-item");
  categoryItem.appendChild(categoryTitle);
  categoryItem.appendChild(categoryP);
  contentDiv.appendChild(categoryItem);
  categoryTitle.innerHTML = "Category: ";
  categoryP.innerHTML = category;

  var contactNumberItem = document.createElement("div");
  var contactNumberTitle = document.createElement("h5");
  var contactNumberP = document.createElement("p");
  contactNumberItem.classList.add("line-item");
  contactNumberItem.appendChild(contactNumberTitle);
  contactNumberItem.appendChild(contactNumberP);
  contentDiv.appendChild(contactNumberItem);
  contactNumberTitle.innerHTML = "Contact Number: ";
  contactNumberP.innerHTML = contactNumber;

  var emailAddressItem = document.createElement("div");
  var emailAddressTitle = document.createElement("h5");
  var emailAddressP = document.createElement("p");
  emailAddressItem.classList.add("line-item");
  emailAddressItem.appendChild(emailAddressTitle);
  emailAddressItem.appendChild(emailAddressP);
  contentDiv.appendChild(emailAddressItem);
  emailAddressTitle.innerHTML = "Email Address: ";
  emailAddressP.innerHTML = email;

  var typeItem = document.createElement("div");
  var typeTitle = document.createElement("h5");
  var typeP = document.createElement("p");
  typeItem.classList.add("line-item");
  typeItem.appendChild(typeTitle);
  typeItem.appendChild(typeP);
  contentDiv.appendChild(typeItem);
  typeTitle.innerHTML = "Entity Type: ";
  typeP.innerHTML = entityType;

  var socialMediaItem = document.createElement("div");
  var socialMediaTitle = document.createElement("h5");
  var socialMediaP = document.createElement("p");
  socialMediaItem.classList.add("line-item");
  socialMediaItem.appendChild(socialMediaTitle);
  socialMediaItem.appendChild(socialMediaP);
  contentDiv.appendChild(socialMediaItem);
  socialMediaTitle.innerHTML = "Social Media: ";
  socialMediaP.innerHTML = tags;

  var websiteItem = document.createElement("div");
  var websiteTitle = document.createElement("h5");
  var websiteTitleAnchor = document.createElement("a");
  var websiteP = document.createElement("p");
  websiteTitleAnchor.href = website;
  websiteTitleAnchor.target = "_blank";
  websiteItem.classList.add("line-item");
  websiteItem.appendChild(websiteTitle);
  websiteTitleAnchor.appendChild(websiteP);
  websiteItem.appendChild(websiteTitleAnchor);
  contentDiv.appendChild(websiteItem);
  websiteTitle.innerHTML = "Websites: ";
  websiteP.innerHTML = website;

  listItemTitleHolder.appendChild(nameElement);
  listItemTitleHolder.appendChild(categoryElement);

  listItemHolder.appendChild(listItem);

  header.addEventListener("click", () => {
    if (contentDiv.style.display == "block") {
      contentDiv.style.display = "none";
      collapseArrow.style.rotate = "90deg";
      header.style.backgroundColor = "transparent";
    } else {
      var urlSearchParams = new URLSearchParams();

      urlSearchParams.set("provider", providerID);
      // window.location.href = "/?" + urlSearchParams.toString();
      window.history.pushState(null, "", "/?" + urlSearchParams.toString());

      contentDiv.style.display = "block";
      collapseArrow.style.rotate = "180deg";
      header.style.backgroundColor = "#969696";
      header.focus();
    }
  });

  goToSearchParamOnPageLoad(providerID, header);
}

//Submitting data in the contact form:
document.getElementById("contact-form").addEventListener("submit", (event) => {
  event.preventDefault();

  var name = document.getElementById("name").value;
  var email = document.getElementById("email").value;
  var message = document.getElementById("message").value;
  
  const newPostKey = push(child(ref(database), 'contacts')).key;

  set(ref(database, "contacts/" + newPostKey), {
    name: name,
    email: email,
    message: message
  });

  alert("Your message has been sent!");

});

//Search functionality:
document.getElementById("provider-search").addEventListener("input", filterListItems);

function filterListItems(searchQuery) {
  var listHolder = document.getElementById("modal-content");

  for (var i = 0; i < listHolder.children.length; i++) {
    for (var j = 0; j < listHolder.children[i].children.length; j++) {
      if (!listHolder.children[i].children[j].innerHTML.toLowerCase().includes(searchQuery.target.value.toLowerCase()) || !listHolder.children[i].innerHTML.toLowerCase().includes(searchQuery.target.value.toLowerCase())) {
        listHolder.children[i].children[j].parentElement.style.display = "none";
      }
      else {
        if (listHolder.children[i].children[j].parentElement.id != "loading-animation") listHolder.children[i].children[j].parentElement.style.display = "block";
      }
    }
  }
}

function goToSearchParamOnPageLoad(searchParams, element) {
  var urlSearchParams = new URLSearchParams(window.location.search);
  var providerParam = urlSearchParams.get("provider");

  if (searchParams == providerParam) {
    modal = document.getElementsByTagName("dialog")[0].showModal();
    element.focus();
    element.children[0].style.rotate = "180deg";
    element.parentElement.children[1].style.display = "block";
  }
}